import { TipoDocumentoEnum } from '@/store/modules/renovacao-crlv';

export enum TipoDocumento {
  REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA = "Requerimento",
  CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL = "Contrato Social/Arrendamento Mercantil",
  COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO = "Comprovante de Pagamento da Taxa de Inclusão",
  COPIA_CRLV = "Cópia da CRLV",
  APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA = "Apólice de Seguro Assinada e Carimbada pela Seguradora",
  LAUDO_TECNICO = "Laudo Técnico",
  ART = "ART",
  //VISTORIA = "Vistoria",
  REQUERIMENTO_TRANSPORTADORA_ASSINADO = "Requerimento assinado pelo responsável da transportadora especificando o pleito",
  CERTIDAO_NEGATIVA_FALENCIA = "Certidão negativa de falência e recuperação judicial expedida",
  BALANCO_PATRIMONIAL = "Balanço patrimonial - exceto as transportadoras com menos de um ano de constituição, e quando ME, EPP e EMPRESÁRIO INDIVIDUAL são dispensadas;",
  //CERTIDAO_DEBITO_PECUNIARIO_DETRAN = "Certidão de inexistência de débito pecuniário Detran",
  //CERTIDAO_DEBITO_PECUNIARIO_ARCE = "Certidão de inexistência de débito pecuniário Arce",
  APOLICE_SEGURO_RESPONSABILIDADE_CIVIL = "Apólice de seguro de responsabilidade civil",

  APOLICE_SEGURO = "Apólice de seguro",

  CERTIDAO_NEGATIVA_DISTRIBUIDOR = 'Certidão negativa do distribuidor',
  CERTIDAO_INEXISTENCIA_DEBITO = 'Certidão de inexistência de débito',
  CERTIDAO_NEGATIVA_ARCE = 'Certidão Negativa de Débitos – ARCE',

  CONTRATO_SOCIAL = "Contrato Social",

  CERTIDAO_NEGATIVA_FEDERAL = 'Certidão de Quitação – Fazenda Federal',
  CERTIDAO_NEGATIVA_ESTADUAL = 'Certidão de Quitação – Fazenda Estadual',
  CERTIDAO_NEGATIVA_MUNICIPAL = 'Certidão de Quitação – Fazenda Municipal',

  PROVA_INCRICAO_CADASTRO_NACIONAL_PESSOA_JURIDICA = "Prova de inscrição no Cadastro Nacional de Pessoas Jurídicas – CNPJ (CNAE 4929902 ou Agência de Viagens)",

  REQUERIMENTO_APRESENTAR_CONTRATO_SOCIAL_SOCIEDADE_COMERCIAL_EPP = "Requerimento ou Apresentar contrato Social se Sociedade Comercial EPP, ou no caso de Sociedade por ações  ME",

  CERTIDAO_REGULAR_DA_ARCE = "Certidão Regular da ARCE",

  CADASTRO_NACIONAL_PESSOAS_JURIDICAS = "Prova de inscrição no Cadastro Nacional de Pessoas Jurídicas – CNPJ (CNAE 4929902 ou Agência de Viagens).",

  //FOTOS
  FOTO_DA_FRENTE_DO_VEICULO = "Foto da frente do veículo",
  FOTO_DA_TRASEIRA_DO_VEICULO = "Foto da traseira do veículo",
  FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA = "Foto lateral referente ao lado do motorista",
  FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS = "Foto lateral referente ao lado de entrada dos passageiros",
  FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS = "Foto interior do veículo a partir das primeiras poltronas",
  FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS = "Foto interior do veículo a partir das últimas poltronas",
  FOTO_CHASSI = "Foto do chassi",

  //substituição de cooperado
  RG = 'Cédula de Identidade (RG)',
  CPF = 'CPF',
  CARTEIRA_RESERVISTA = 'Carteira de reservista',
  COMPROVANTE_SERVICO_MILITAR = 'Comprovação de Regularidade com o Serviço Militar',
  // CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_CIVIL = 'Certidão negativa de antecedentes criminais da Polícia Civil',
  COPIA_CNH_CATEGORIA_D_OU_E = 'Cópia da Carteira Nacional de Habilitação (CNH) na categoria D ou E, na forma estabelecida pelo CONTRAN – Conselho Nacional de Trânsito, devendo estar em plena validade.',
  CERTIDAO_NEGATIVA_ANT_CRIMINAIS_MILITAR = 'Certidão de Antecedentes Criminais – Justiça Militar',
  CERTIDAO_NEGATIVA_ANT_CRIMINAIS_COMUM = 'Certidão de Antecedentes Criminais – Justiça Estadual',
  CERTIDAO_NEGATIVA_ANT_CRIMINAIS_ELEITORAL = 'Certidão de Antecedentes Criminais – Justiça Eleitoral',
  CERTIDAO_NEGATIVA_ANT_CRIM_FED_COMUM = 'Certidão de Antecedentes Criminais – Justiça Federal Comum',
  // CERTIDAO_NEGATIVA_ANT_CRIM_POLICIA_FEDERAL = 'Certidão negativa de antecedentes criminais da Polícia Federal',
  CERTIDAO_NEGATIVA_DEBITOS_DETRAN_CE = 'Certidão Negativa de Débitos – DETRAN',
  CERTIDAO_HISTORICO_INFRACOES = 'Certidão emitida por Órgão Executivo de Trânsito (DETRAN/CE ou equivalente) que expediu a CNH do cooperativado, em seu nome, contendo o nome, CPF, nº CNH, tempo de habilitação nas Categorias D e E, e o histórico das infrações ativas ao Código de Trânsito Brasileiro por ele cometidas, discriminando por tipo (gravíssima, grave, média e leve) e a pontuação acumulada em decorrência destas infrações que não poderá superar o teto de 20 (vinte) pontos definido pelo Código de Trânsito Brasileiro na data de apresentação da proposta.',
  CERTIFICADO_CURSO_CAPACITACAO_OBRIGATORIO = 'Certificado de curso de capacitação obrigatório',
  CERTIDAO_NEGATIVA_ANT_CRIM_FED_MILITAR = 'Certidão de Antecedentes Criminais – Justiça Federal Militar',
  COMPROVANTE_ENDERECO = 'Comprovante de Endereço',
  COMPROVANTE_ULTIMA_ELEICAO = 'Certidão de Quitação Eleitoral – expedida pelo TRE',
  TERMO_ANUENCIA = 'Termo de Anuência'
}

export const TipoDocumentoPorTipoPedido = [
  {
    tipoPedido: 'RENOVACAO_REGISTRO_VEICULO',
    documentos: [
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.COPIA_CRLV,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: 'DETRAN',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.LAUDO_TECNICO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.ART,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: 'CREA',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_DA_FRENTE_DO_VEICULO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_DA_TRASEIRA_DO_VEICULO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_CHASSI,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
    ],
  },

  {
    tipoPedido: 'INCLUSAO_VEICULO',
    documentos: [
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.COMPROVANTE_PAGAMENTO_TAXA_INCLUSAO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CONTRATO_SOCIAL_ARRENDAMENTO_MERCANTIL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.COPIA_CRLV,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: 'DETRAN',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.LAUDO_TECNICO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.ART,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: 'CREA',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_DA_FRENTE_DO_VEICULO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_DA_TRASEIRA_DO_VEICULO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.FOTO_CHASSI,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
    ],
  },

  {
    tipoPedido: 'EXCLUSAO_VEICULO',
    documentos: [
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
    ],
  },

  {
    tipoPedido: 'RENOVACAO_CADASTRO_TRANSPORTADORA',
    documentos: [
      //{ file: null , tipoDocumento: TipoDocumentoEnum.VISTORIA, dataEmissao: "", dataValidade: "", orgaoExpedidor: "", numeroComplemento: "",filename: "", type: "", size: "", error: false, progress: 0, uploaded: false },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_TRANSPORTADORA_ASSINADO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_FALENCIA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.BALANCO_PATRIMONIAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_RESPONSABILIDADE_CIVIL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_REGULAR_DA_ARCE,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
    ],
  },

  {
    tipoPedido: 'CADASTRO_TRANSPORTADORA',
    documentos: [
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      // {
      //   file: null,
      //   tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO,
      //   dataEmissao: "",
      //   dataValidade: "",
      //   orgaoExpedidor: "",
      //   numeroComplemento: "",
      //   filename: "",
      //   type: "",
      //   size: "",
      //   error: false,
      //   progress: 0,
      //   uploaded: false,
      // },
      // {
      //   file: null,
      //   tipoDocumento: TipoDocumentoEnum.APOLICE_SEGURO_RESPONSABILIDADE_CIVIL,
      //   dataEmissao: "",
      //   dataValidade: "",
      //   orgaoExpedidor: "",
      //   numeroComplemento: "",
      //   filename: "",
      //   type: "",
      //   size: "",
      //   error: false,
      //   progress: 0,
      //   uploaded: false,
      // },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.BALANCO_PATRIMONIAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      // {
      //   file: null,
      //   tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ARCE,
      //   dataEmissao: "",
      //   dataValidade: "",
      //   orgaoExpedidor: "",
      //   numeroComplemento: "",
      //   filename: "",
      //   type: "",
      //   size: "",
      //   error: false,
      //   progress: 0,
      //   uploaded: false,
      //   complementar: true,
      // },
      // {
      //   file: null,
      //   tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_DISTRIBUIDOR,
      //   dataEmissao: "",
      //   dataValidade: "",
      //   orgaoExpedidor: "",
      //   numeroComplemento: "",
      //   filename: "",
      //   type: "",
      //   size: "",
      //   error: false,
      //   progress: 0,
      //   uploaded: false,
      //   complementar: true,
      //   fretamento: true,
      // },
      // {
      //   file: null,
      //   tipoDocumento: TipoDocumentoEnum.CERTIDAO_INEXISTENCIA_DEBITO,
      //   dataEmissao: "",
      //   dataValidade: "",
      //   orgaoExpedidor: "",
      //   numeroComplemento: "",
      //   filename: "",
      //   type: "",
      //   size: "",
      //   error: false,
      //   progress: 0,
      //   uploaded: false,
      //   complementar: true,
      // },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_FALENCIA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CONTRATO_SOCIAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_FEDERAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ESTADUAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_MUNICIPAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CADASTRO_NACIONAL_PESSOAS_JURIDICAS,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
    ],
  },

  {
    tipoPedido: 'SUBSTITUICAO_COOPERADO',
    documentos: [
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.RG,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CPF,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CARTEIRA_RESERVISTA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.COPIA_CNH_CATEGORIA_D_OU_E,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ANT_CRIM_FED_MILITAR,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ARCE,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ANT_CRIMINAIS_MILITAR,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ANT_CRIMINAIS_COMUM,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ANT_CRIMINAIS_ELEITORAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ANT_CRIM_FED_COMUM,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_FEDERAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_ESTADUAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_MUNICIPAL,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_NEGATIVA_DEBITOS_DETRAN_CE,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIDAO_HISTORICO_INFRACOES,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.CERTIFICADO_CURSO_CAPACITACAO_OBRIGATORIO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.COMPROVANTE_SERVICO_MILITAR,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.COMPROVANTE_ENDERECO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.COMPROVANTE_ULTIMA_ELEICAO,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
        complementar: true,
        fretamento: true,
      },
      {
        file: null,
        tipoDocumento: TipoDocumentoEnum.TERMO_ANUENCIA,
        dataEmissao: '',
        dataValidade: '',
        orgaoExpedidor: '',
        numeroComplemento: '',
        filename: '',
        type: '',
        size: '',
        error: false,
        progress: 0,
        uploaded: false,
      },
    ],
  },
];
